import _objectSpread from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import { iconLogoWordmark } from '@tesla/design-system-icons';
import cx from 'classnames';
import React from 'react';
import { Icon } from '../icon/icon.js';
export var SiteLogo = function SiteLogo(_ref) {
  var appTitle = _ref.appTitle,
      appTitleHref = _ref.appTitleHref,
      className = _ref.className,
      _ref$href = _ref.href,
      href = _ref$href === void 0 ? '/' : _ref$href,
      label = _ref.label,
      _ref$skipLink = _ref.skipLink,
      skipLink = _ref$skipLink === void 0 ? 'Skip to main content' : _ref$skipLink,
      _ref$skipLinkTarget = _ref.skipLinkTarget,
      skipLinkTarget = _ref$skipLinkTarget === void 0 ? 'main-content' : _ref$skipLinkTarget,
      rest = _objectWithoutProperties(_ref, ["appTitle", "appTitleHref", "className", "href", "label", "skipLink", "skipLinkTarget"]);

  var skipLinkHref = skipLinkTarget.startsWith('#') ? skipLinkTarget : "#".concat(skipLinkTarget);
  return React.createElement("h1", _objectSpread({
    className: cx('tds-site-logo', 'tds-align--start', className)
  }, rest), React.createElement("a", {
    "aria-label": "Tesla Logo",
    className: "tds-site-logo-link",
    href: href
  }, React.createElement(Icon, {
    className: "tds-site-logo-icon",
    data: iconLogoWordmark
  }), label && React.createElement("span", {
    className: "tds--is_visually_hidden"
  }, label)), appTitle && React.createElement("a", {
    className: "tds-app-title",
    href: appTitleHref
  }, React.createElement("span", {
    className: "tds-app-title-text"
  }, appTitle)), React.createElement("a", {
    className: "tds-skip-to-content tds--is_visually_hidden",
    href: skipLinkHref,
    id: "top-of-page"
  }, skipLink));
};